import { render } from "./BadgeWarning.vue?vue&type=template&id=81cffdd6"
import script from "./BadgeWarning.vue?vue&type=script&lang=js"
export * from "./BadgeWarning.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__